import { useLocation, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { routes } from '.';
import { Container, Nav } from '../components';

const Root = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode='wait'>
      <Container>
        {location.pathname !== '/' && <Nav />}
        <Routes
          location={location}
          key={location.pathname}
        >
          {routes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}
        </Routes>
      </Container>
    </AnimatePresence>
  );
};

export default Root;
